import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { MaterialSummaryDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { getContext } from 'store/getContext'
import { newProjectActions } from '../newProjectReducer'
import { bomItemSelector } from '../selectors/bomItemSelector'
import { fetchProject } from './fetchProject'

export const saveBomItemMaterials = createAsyncThunk<any, any, { state: any }>(
  'boM/saveMaterial',
  async (
    {
      bomItemId,
      material,
    }: {
      bomItemId: string
      material: MaterialSummaryDto
    },
    thunkAPI
  ) => {
    const { partyId: organizationId, projectId } = getContext(thunkAPI.getState)

    const controller = new BomItemController(organizationId, projectId)

    const bomItem = bomItemSelector(thunkAPI.getState(), bomItemId)

    const bomItemIds =
      bomItem?.type === 'MaterialHeader'
        ? bomItem.filteredPartTypeIds
        : [bomItemId]

    try {
      thunkAPI.dispatch(newProjectActions.resetBomItemFinancials(bomItemIds))

      await controller.SetKeywordsOrArticleToParts({
        rowId: bomItemIds,
        keywords: Object.values(material.tokens)?.flat(),
        articleId: material.id,
        articleDescription: material.description,
        headerId: bomItem.type === 'MaterialHeader' ? bomItemId : null,
      })
    } catch (err) {
      ShowException('saveBomItemMaterials', err)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
